import { css, html, renderIf, LitEntity, SirenActionMixin } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import { bannerStyles } from '../styles/banner-styles';

import './parts/device-list-item';
import '../common/bn-icon';
import '../common/bn-loading';

class DeviceList extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.devices = [];
    this.detailsViewable = {};
  }

  static get properties() {
    return {
      flagname: { type: String },
      devices: { type: Array, attribute: false },
      isFetching: { type: Boolean, attribute: false },
      detailsViewable: { type: Object, attribute: false },
      renderItem: { type: Function },
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles, css`
      .device-list {
        display: flex;
        flex-direction: column;
      }
      .list-item {
        width: 100%;
      }
    `];
  }

  render() {
    if (!this.entity || this.loading) {
      return html`<bn-loading></bn-loading>`;
    }

    return html`
      <div class="device-list">
        ${renderIf(!this.devices || this.devices.length === 0, html`
          <slot name="no-devices"></slot>
        `)}

        ${this.devices.map((device) => this._renderDevice(device))}
      </div>

      <bn-load-more-button
        .href="${this.href}"
        @moreloaded="${this._onMoreLoaded}"
      ></bn-load-more-button>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);

    if (this.entity && this.entity.entities) {
      this.devices = this.entity.entities;
    } else {
      this.devices = [];
    }
  }

  async _onMoreLoaded(e) {
    const { entity } = e.detail;
    this.devices = [...this.devices, ...entity.entities];
  }

  _renderDevice(device) {
    if (!this.renderItem) {
      return html`
        <bn-surface class="banner banner--critical">
          No renderItem function provided to <code>&lt;device-list&gt;</code>
        </bn-surface>
      `;
    }

    return this.renderItem({
      device,
      detailsViewable: this.detailsViewable[device.getLinkByRel('self').href],
      onDetailsClicked: this._onDetailsClicked,
    });
  }

  _onDetailsClicked(e) {
    const { detail } = e;
    if (!detail) {
      return;
    }

    this.detailsViewable[detail.href] = detail.detailsviewable;
    this.requestUpdate();
  }
}

window.customElements.define('device-list', DeviceList);
